import { ActionType, Action, assetInfo } from "../actions/types"

const initialAssetInfoState: assetInfo = {
  asset: {
    id: "",
    tractor: "",
    trailer: "",
    usdot: "",
    companyName: "",
    referenceNumber: "",
    estimatedCheckout: "",
    HOS: "",
    RFIDCode: "",
    equipmentType: "",
    trailerStatus: "",
    permalink: ""
  }
}

const assetInfoReducer = (
  state: assetInfo = initialAssetInfoState,
  action: Action
) => {
  switch (action.type) {
    case ActionType.SET_ASSET_INFO:
      return {
        ...state,
        asset: action.payload
      }
    default:
      return state
  }
}

export default assetInfoReducer
